<template>
  <div class="dwp-border-t dwp-border-gray-200 dwp-mx-10 dwp-cursor-pointer dwp-mb-4" v-if="!edit">
    <div class="dwp-flex dwp-py-4 dwp-items-center dwp-space-x-1" @click="edit = true">
      <PlusIcon class="dwp-text-primary dwp-w-5 dwp-h-5" />
      <div class="dwp-text-gray-500 wpl-flex-1">Add task</div>
    </div>
  </div>

  <div class="dwp-space-y-4 dwp-mb-4" v-else>
    <div class="dwp-mx-6 dwp-rounded dwp-shadow-xl dwp-leading-none">
      <TaskTemplate class="dwp-shadow-xs dwp-bg-white dwp-px-4 dwp-py-5 dwp-rounded bwp-mb-4">
        <template #checkbox>
          <Checkbox class="dwp-block dwp-leading-normal" />
        </template>

        <template #title>
          <input
            type="text"
            @keydown.enter="add"
            @keydown.esc="cancel"
            ref="title"
            class="dwp-outline-none dwp-text-gray-700 dwp-placeholder-gray-500 dwp-leading-none dwp-w-full"
            placeholder="New Task"
            v-model="form.title"
          />
        </template>

        <template #content>
          <Editor
            ref="content"
            class="dwp-outline-none dwp-text-gray-600 dwp-text-sm dwp-leading-normal"
            placeholder="Notes"
            @keydown.esc="cancel"
            :content.sync="form.notes"
          />
        </template>
      </TaskTemplate>
    </div>
    <div class="dwp-mx-10" v-if="edit">
      <VButton @click.native="add">Add Task</VButton>
      <VButton type="plain" @click.native="cancel">Cancel</VButton>
    </div>
  </div>
</template>

<script>
import VButton from "./ui/VButton.vue";
import TextInput from "./ui/TextInput.vue";
import { PlusIcon } from "vue-feather-icons";
import { call, get } from "vuex-pathify";
import Checkbox from "./Checkbox.vue";
import Editor from "./shared/Editor.vue";
import TaskTemplate from "./templates/TaskTemplate.vue";

import { CircleIcon } from "vue-feather-icons";

import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],

  components: {
    VButton,
    TextInput,
    Checkbox,
    Editor,
    TaskTemplate,
    PlusIcon,
  },

  data() {
    return {
      edit: false,
      form: {
        title: "",
        notes: "",
      },
    };
  },

  computed: {
    disabled() {
      return !this.form.title || this.form.title == "<p></p>";
    },
  },

  watch: {
    edit(val) {
      if (val) {
        this.$emit("edit");
        this.$nextTick(() => {
          this.$refs.title.focus();
        });
      }
    },
  },

  methods: {
    ...call("tasks/*"),
    async add(e) {
      if (this.disabled) {
        this.$refs.title.focus();
        e.preventDefault();
        return;
      }
      console.log(this);
      this.addTask({
        data: {
          list_id: this.currentListId,
          title: this.form.title,
          notes: this.form.notes,
        },
      });
      this.form.title = "";
      this.form.notes = "";
    },
    cancel() {
      this.edit = false;
      this.form.title = "";
      this.form.notes = "";
    },
  },
};
</script>

<style>
.dwp-open-transitions {
  transition: box-shadow 0.2 ease, padding 0.2 ease;
}
</style>
